<template>
  <div class="container learnstyle-page">
    <el-row class="grid-head"></el-row>
    <el-row>
      <div>
        <div class="subject">
          <div id="nav">
            <a @click="selectSubject(null)" :class="selectId === 0 ? 'on' : ''">全部</a>
            <a v-for="subject in studentSubjectList"
               :key="subject.id"
               :class="subject.id === selectId ? 'on' : ''"
               @click="selectSubject(subject)" >{{subject.name}}</a>
          </div>
        </div>

        <div class="exam_list">
          <el-card v-if="hasTestPaperInfo" v-for="(testPaper, index) in testPaperList" :key="index" class="box-card">
            <div slot="header" class="clearfix">
              <span>{{testPaper.name}}</span>
            </div>
            <div class="text item">
              科目：  <el-tag>{{testPaper.subjectName}}</el-tag>
            </div>

            <div class="text item">
              试题数量： {{testPaper.questionNumber}}题
            </div>

            <div class="text item">
              总分： {{testPaper.mark}}分
            </div>

            <div class="text item">
              考试时间： {{testPaper.examTime}}分钟
            </div>

            <div class="text item">
              参考人数： {{testPaper.examNumber}}人
            </div>

            <div style="border-bottom: 1px solid #EBEEF5" class="text item">
              发布时间： {{testPaper.publishTime}}
            </div>

            <div class="text item">
              <el-button
                @click="startExam(testPaper)"
                style="float: right; font-size: 18px" type="text">开始考试</el-button>
            </div>
          </el-card>

          <el-card v-if="!hasTestPaperInfo" class="no_data">
            <i class="el-icon-takeaway-box"></i> 暂无考试信息
          </el-card>
        </div>
      </div>
    </el-row>

    <div class="block">
      <el-pagination
        background
        v-if="totalCount > pageSize"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>

  export default {
    name: 'exam',
    data () {
      return {
        hasTestPaperInfo: true,
        selectId: 0,
        testPaperList: [],
        studentSubjectList: [],
        currentPage: 1,
        pageSize: 9,
        totalCount: 0,
        subjectId: ''
      }
    },

    mounted () {
      this.startDate = new Date().getTime()
      this.getStudentSubjectList()
      this.getTestPaperList()
    },

    destroyed () {

    },

    methods: {

      selectSubject (subject) {
        if (subject) {
          this.selectId = subject.id
          this.subjectId = subject.id
        } else {
          this.selectId = 0
          this.subjectId = ''
        }
        this.getTestPaperList()
      },

      getTestPaperList () {
        this.axios.get(this.$httpApi.httpUrl('/student/testPaperInfo/list'), {
          params: {
            pageNumber: this.currentPage,
            pageSize: this.pageSize,
            subjectId: this.subjectId
          }
        }).then(response => {
          this.testPaperList = response.data.data.dataList
          if (this.testPaperList.length === 0) {
            this.hasTestPaperInfo = false
          } else {
            this.hasTestPaperInfo = true
          }
          this.totalCount = response.data.data.total
        })
      },

      // 获取学员学习科目
      getStudentSubjectList () {
        this.axios.get(this.$httpApi.httpUrl('/student/subjectInfo/selectByGradeInfoId'), {
          params: {

          }
        }).then(response => {
          this.studentSubjectList = response.data.data
        })
      },

      startExam (testPaperInfo) {
        this.$confirm('确定开始考试吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.commit('common/updateTestPaperInfo', testPaperInfo)
          this.$router.push({
            name: 'examQuestion',
          })
        }).catch(() => {

        })
      }
    }
  }
</script>


<style scoped>

  .el-row .box-card {
    width: 30% !important;
    display: inline-block !important;
    margin: 15px !important;
  }

  .no_data {
    margin-top: 40px;
    line-height: 300px;
    text-align: center;
    font-size: 20px;
    color: rgb(155, 155, 155);
  }
  .exam_list {
    width: 100%;
    min-height: 300px;
    display: inline-block;
  }

  .el-pagination {
    margin-top: 25px;
    text-align: center;
  }

  .subject .on {
    background: rgba(204,136,0,.1);
    color: #c80;
  }

  .subject a {
    font-size: 15px;
    line-height: 40px;
    min-width: 60px;
    padding: 0 15px;
    margin-top: 10px;
    margin-right: 25px;
    float: left;
  }

  .subject a:hover {
    cursor: pointer;
    background: rgba(204,136,0,.1);
    color: #c80;
  }

  .paper {
    cursor: pointer;
  }
  .el-button {
    font-size: 12px;
  }
  .title {
    font-weight: 700;
    font-size: 16px;
  }
  .paper a:hover {
    color: #11a68d;
  }

  .el-table {
    top: 15px;
  }

  .top .item {
    margin-left: 20px;
  }
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 5px;
    padding-bottom: 5px;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
  .grid-head{margin-bottom: 30px;}
  .grid-content-right{text-align: right;color:#24794b;}
  .grid-content-right:hover {
    color: #3a8ee6;
    cursor: pointer;
  }
  .grid-content-left{text-align: left;color:#24794b;}
</style>



// WEBPACK FOOTER //
// src/views/education/exam.vue